import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { useTheme } from '@/contexts/ThemeContext'
import { createTextFieldStyles } from '@/components/shared/commonStyles'
import { TRANSACTION_TYPES } from './types'
import type { SelectProps } from '@mui/material'

interface TransactionTypeSelectProps {
  value: string
  onChange: (value: string) => void
  label?: string
  size?: 'small' | 'medium'
  fullWidth?: boolean
  sx?: SelectProps['sx']
}

export default function TransactionTypeSelect({
  value,
  onChange,
  label = 'Type',
  size = 'medium',
  fullWidth = true,
  sx,
}: TransactionTypeSelectProps) {
  const { colors } = useTheme()

  return (
    <FormControl fullWidth={fullWidth} size={size} sx={sx}>
      <InputLabel
        sx={{
          color: colors.text,
          opacity: 0.7,
          '&.Mui-focused': {
            color: (colors as { yellow?: string }).yellow || colors.primary,
          },
        }}
      >
        {label}
      </InputLabel>
      <Select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        label={label}
        sx={{
          ...createTextFieldStyles(colors),
          '& .MuiSelect-select': {
            color: colors.text,
          },
          '& .MuiSelect-icon': {
            color: `${colors.text} !important`,
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: `${colors.primary} !important`,
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: `${colors.primary} !important`,
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: `${
              (colors as { yellow?: string }).yellow || colors.primary
            } !important`,
            borderWidth: '2px',
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              backgroundColor: colors.background,
              border: `1px solid ${colors.primary}`,
              '& .MuiMenuItem-root': {
                color: colors.text,
                '&:hover': {
                  backgroundColor: `${colors.primary}20`,
                },
                '&.Mui-selected': {
                  backgroundColor: `${colors.primary}33`,
                  color: colors.primary,
                  '&:hover': {
                    backgroundColor: `${colors.primary}40`,
                  },
                },
              },
            },
          },
        }}
      >
        {TRANSACTION_TYPES.map((type) => (
          <MenuItem key={type.value} value={type.value}>
            {type.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
